import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ad90d35"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "is-nav is-sticky" }
const _hoisted_2 = { class: "search_contents_wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search_title" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "search_title_text" }, "求人検索")
], -1))
const _hoisted_4 = { class: "search_layout" }
const _hoisted_5 = { class: "search_layout_block_keyword" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search_layout_block_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "search_item_title" }, "キーワード")
], -1))
const _hoisted_7 = { class: "search_layout_block_form" }
const _hoisted_8 = { class: "search_item_form" }
const _hoisted_9 = { class: "search_layout_block_selectbox" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search_layout_block_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "search_item_title" }, "業種")
], -1))
const _hoisted_11 = { class: "search_layout_block_form" }
const _hoisted_12 = { class: "search_item_add" }
const _hoisted_13 = { class: "search_layout_block_selectbox" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search_layout_block_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "search_item_title" }, "職種")
], -1))
const _hoisted_15 = { class: "search_layout_block_form" }
const _hoisted_16 = { class: "search_item_add" }
const _hoisted_17 = { class: "search_layout_block_selectbox" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search_layout_block_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "search_item_title" }, "勤務地")
], -1))
const _hoisted_19 = { class: "search_layout_block_form" }
const _hoisted_20 = { class: "search_item_form" }
const _hoisted_21 = { class: "search_layout_block" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search_layout_block_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "search_item_title" }, "雇用形態")
], -1))
const _hoisted_23 = { class: "search_layout_block_form" }
const _hoisted_24 = { class: "search_item_checkbox" }
const _hoisted_25 = { class: "search_layout_block" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search_layout_block_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "search_item_title" }, "給与")
], -1))
const _hoisted_27 = { class: "search_layout_block_form" }
const _hoisted_28 = { class: "search_column_2" }
const _hoisted_29 = { class: "search_column_2_item" }
const _hoisted_30 = { class: "search_column_2_item_inner" }
const _hoisted_31 = { class: "search_column_2_item_inner_input" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search_column_2_item_inner_suffix" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "search_column_2_item_inner_suffix_text" }, "万円〜")
], -1))
const _hoisted_33 = { class: "search_column_2_item" }
const _hoisted_34 = { class: "search_column_2_item_inner" }
const _hoisted_35 = { class: "search_column_2_item_inner_input" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search_column_2_item_inner_suffix" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "search_column_2_item_inner_suffix_text" }, "万円")
], -1))
const _hoisted_37 = { class: "search_layout_block" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search_layout_block_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "search_item_title" }, "こだわりで選ぶ")
], -1))
const _hoisted_39 = { class: "search_layout_block_form" }
const _hoisted_40 = { class: "search_item_checkbox" }
const _hoisted_41 = { class: "search_layout_readmore" }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { class: "search_layout_block" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search_layout_block_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "search_item_title" }, "働き方")
], -1))
const _hoisted_45 = { class: "search_layout_block_form" }
const _hoisted_46 = { class: "search_item_checkbox" }
const _hoisted_47 = { class: "search_layout_block" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search_layout_block_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "search_item_title" }, "支援・補助制度")
], -1))
const _hoisted_49 = { class: "search_layout_block_form" }
const _hoisted_50 = { class: "search_item_checkbox" }
const _hoisted_51 = { class: "search_layout_block" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search_layout_block_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "search_item_title" }, "オフィスの環境")
], -1))
const _hoisted_53 = { class: "search_layout_block_form" }
const _hoisted_54 = { class: "search_item_checkbox" }
const _hoisted_55 = { class: "search_layout_block" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search_layout_block_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "search_item_title" }, "会社規模")
], -1))
const _hoisted_57 = { class: "search_layout_block_form" }
const _hoisted_58 = { class: "search_item_checkbox" }
const _hoisted_59 = { class: "search_layout_block" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search_layout_block_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "search_item_title" }, "会社の雰囲気")
], -1))
const _hoisted_61 = { class: "search_layout_block_form" }
const _hoisted_62 = { class: "search_item_checkbox" }
const _hoisted_63 = { class: "search_layout_block" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search_layout_block_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "search_item_title" }, "応募条件")
], -1))
const _hoisted_65 = { class: "search_layout_block_form" }
const _hoisted_66 = { class: "search_item_checkbox" }
const _hoisted_67 = { class: "search_layout_readmore" }
const _hoisted_68 = { class: "search_layout_block_number" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search_layout_block_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "search_item_title" }, "求人No")
], -1))
const _hoisted_70 = { class: "search_layout_block_form" }
const _hoisted_71 = { class: "search_item_form" }
const _hoisted_72 = { class: "search_layout_button" }
const _hoisted_73 = { class: "search_layout_button_inner" }
const _hoisted_74 = { class: "search_button_clear" }
const _hoisted_75 = { class: "search_button_search" }

import { ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { useField, useForm } from 'vee-validate';
import { validationRuleHelper } from '@/utils/validationRule';

import BaseButton from '@/components/BaseButton.vue';
import BaseTextForm from '@/components/BaseTextForm.vue';
import BaseCheckbox from '@/components/BaseCheckbox.vue';
import BaseRadioButton from '@/components/BaseRadioButton.vue';
import Loading from '@/components/Loading.vue';
import BaseSelectButton from '@/components/BaseSelectButton.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';
import EditCheckboxModal from '@/components/EditCheckboxModal.vue';
import { CheckboxListType } from '@/types';

import { getMasterSearchConditionWorkArea } from '@/api/masterDataEndpoint';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchView',
  setup(__props) {

const store = useStore();

const sendSearchOrderState = computed(() => {
  return store.getters['searchOrder/sendSearchOrder'];
});
const searchOrderConditions = computed(() => {
  return store.getters['searchOrder/searchOrderConditions'];
});

const { meta, errors } = useForm();
const { value: orderId } = useField('orderId', validationRuleHelper({ numeric: true }), {
  initialValue: sendSearchOrderState.value.orderId || '',
  label: '求人No',
});
const { value: salaryMax } = useField('salaryMax', validationRuleHelper({ betweenValue: [0, 9999] }), {
  initialValue: sendSearchOrderState.value.salaryMax !== null ? sendSearchOrderState.value.salaryMax.toString() : '',
  label: '最大給与',
});
const { value: salaryMin } = useField('salaryMin', validationRuleHelper({ betweenValue: [0, 9999] }), {
  initialValue: sendSearchOrderState.value.salaryMin !== null ? sendSearchOrderState.value.salaryMin.toString() : '',
  label: '最小給与',
});
const salaryErrors = computed(() => {
  const err = [];
  if (errors.value.salaryMax) {
    err.push(errors.value.salaryMax);
  }
  if (errors.value.salaryMin) {
    err.push(errors.value.salaryMin);
  }
  return err;
});

const router = useRouter();
const isLoading = ref(false);
const isShowMoreContents = ref(false);

const keyword = ref(sendSearchOrderState.value.keyword);
const workAreaList = ref<string[]>(sendSearchOrderState.value.wkprefId ? sendSearchOrderState.value.wkprefId.map(String) : []);
const industryList = ref<Array<Array<string>>>(searchOrderConditions.value.indsctgList ? searchOrderConditions.value.indsctgList : [[]]);
const ocupList = ref<Array<Array<string>>>(searchOrderConditions.value.ocupList ? searchOrderConditions.value.ocupList : [[]]);
const emptypeFulltimeemployeeFlg = ref(sendSearchOrderState.value.emptypeFulltimeemployeeFlg);
const emptypeContractemployeeFlg = ref(sendSearchOrderState.value.emptypeContractemployeeFlg);
const emptypeTemporarystaffFlg = ref(sendSearchOrderState.value.emptypeTemporarystaffFlg);
const emptypeIntroductiondispatchingFlg = ref(sendSearchOrderState.value.emptypeIntroductiondispatchingFlg);
const emptypeSubcontractingFlg = ref(sendSearchOrderState.value.emptypeSubcontractingFlg);

const recommendedPoint1_4DayworkFlg = ref(sendSearchOrderState.value.recommendedPoint1_4DayworkFlg);
const recommendedPointWeekendOffFlg = ref(sendSearchOrderState.value.recommendedPointWeekendOffFlg);
const recommendedPointSrtWkhourFlg = ref(sendSearchOrderState.value.recommendedPointSrtWkhourFlg);
const recommendedPoint1_5HourworkFlg = ref(sendSearchOrderState.value.recommendedPoint1_5HourworkFlg);
const recommendedPointNoOvertimeFlg = ref(sendSearchOrderState.value.recommendedPointNoOvertimeFlg);
const recommendedPointOvertimeFlg = ref(sendSearchOrderState.value.recommendedPointOvertimeFlg);
const recommendedPointWorkFrom_10Flg = ref(sendSearchOrderState.value.recommendedPointWorkFrom_10Flg);
const recommendedPointWorkTo_18Flg = ref(sendSearchOrderState.value.recommendedPointWorkTo_18Flg);
const recommendedPointFlextimeFlg = ref(sendSearchOrderState.value.recommendedPointFlextimeFlg);
const recommendedPointSalary_130Flg = ref(sendSearchOrderState.value.recommendedPointSalary_130Flg);
const recommendedPointHomeBasedFlg = ref(sendSearchOrderState.value.recommendedPointHomeBasedFlg);
const recommendedPointSideWorkFlg = ref(sendSearchOrderState.value.recommendedPointSideWorkFlg);
const recommendedPointNoRelocationFlg = ref(sendSearchOrderState.value.recommendedPointNoRelocationFlg);
const recommendedPointTransportPaidFlg = ref(sendSearchOrderState.value.recommendedPointTransportPaidFlg);
const recommendedPointChildcareSupportFlg = ref(sendSearchOrderState.value.recommendedPointChildcareSupportFlg);
const recommendedPointComHouseSupportFlg = ref(sendSearchOrderState.value.recommendedPointComHouseSupportFlg);
const recommendedPointTrainingFlg = ref(sendSearchOrderState.value.recommendedPointTrainingFlg);
const recommendedPointStationFrom_5Flg = ref(sendSearchOrderState.value.recommendedPointStationFrom_5Flg);
const recommendedPointClothingFreeFlg = ref(sendSearchOrderState.value.recommendedPointClothingFreeFlg);
const recommendedPointHairstyleFreeFlg = ref(sendSearchOrderState.value.recommendedPointHairstyleFreeFlg);
const recommendedPointListedFlg = ref(sendSearchOrderState.value.recommendedPointListedFlg);
const recommendedPointForeignComFlg = ref(sendSearchOrderState.value.recommendedPointForeignComFlg);
const recommendedPoint2year_10percentFlg = ref(sendSearchOrderState.value.recommendedPoint2year_10percentFlg);
const recommendedPointFounded_5yearFlg = ref(sendSearchOrderState.value.recommendedPointFounded_5yearFlg);
const recommendedPointMidcareerIn_50Flg = ref(sendSearchOrderState.value.recommendedPointMidcareerIn_50Flg);
const recommendedPointFemale_50percentFlg = ref(sendSearchOrderState.value.recommendedPointFemale_50percentFlg);
const recommendedPointFemaleActiveFlg = ref(sendSearchOrderState.value.recommendedPointFemaleActiveFlg);
const recommendedPointInexperienceFlg = ref(sendSearchOrderState.value.recommendedPointInexperienceFlg);
const recommendedPointSemiGradFlg = ref(sendSearchOrderState.value.recommendedPointSemiGradFlg);
const recommendedPointNoEducationFlg = ref(sendSearchOrderState.value.recommendedPointNoEducationFlg);
const recommendedPointUseEnglishFlg = ref(sendSearchOrderState.value.recommendedPointUseEnglishFlg);
const recommendedPointUseOtherEnglishFlg = ref(sendSearchOrderState.value.recommendedPointUseOtherEnglishFlg);
const recommendedPointManagerRecruitFlg = ref(sendSearchOrderState.value.recommendedPointManagerRecruitFlg);
const recommendedPointUiTurnFlg = ref(sendSearchOrderState.value.recommendedPointUiTurnFlg);
const recommendedPointShufumamaFlg = ref(sendSearchOrderState.value.recommendedPointShufumamaFlg);
const recommendedPointExecutiveFlg = ref(sendSearchOrderState.value.recommendedPointExecutiveFlg);

const empTypeList = ref([
  { label: '正社員', value: emptypeFulltimeemployeeFlg },
  { label: '契約社員', value: emptypeContractemployeeFlg },
]);
const pickUpPointList = ref([
  { label: '土日祝休み', value: recommendedPointWeekendOffFlg },
  { label: '残業なし', value: recommendedPointNoOvertimeFlg },
  { label: '残業月20時間以内', value: recommendedPointOvertimeFlg },
  { label: 'フレックスタイム制', value: recommendedPointFlextimeFlg },
  { label: '在宅・リモートワーク', value: recommendedPointHomeBasedFlg },
  { label: '副業・兼業OK', value: recommendedPointSideWorkFlg },
  { label: '転勤なし', value: recommendedPointNoRelocationFlg },
]);
const recommendedPointList = ref([
  { label: '週1～4日以内の勤務', value: recommendedPoint1_4DayworkFlg },
  { label: '土日祝休み', value: recommendedPointWeekendOffFlg },
  { label: '時短勤務', value: recommendedPointSrtWkhourFlg },
  { label: '勤務時間1日5時間以内', value: recommendedPoint1_5HourworkFlg },
  { label: '残業なし', value: recommendedPointNoOvertimeFlg },
  { label: '残業月20時間以内', value: recommendedPointOvertimeFlg },
  { label: '始業10時以降', value: recommendedPointWorkFrom_10Flg },
  { label: '終業18時以前', value: recommendedPointWorkTo_18Flg },
  { label: 'フレックスタイム制', value: recommendedPointFlextimeFlg },
  { label: '年収130万円以内', value: recommendedPointSalary_130Flg },
  { label: '在宅・リモートワーク', value: recommendedPointHomeBasedFlg },
  { label: '副業・兼業OK', value: recommendedPointSideWorkFlg },
  { label: '転勤なし', value: recommendedPointNoRelocationFlg },
  { label: '交通費全額支給', value: recommendedPointTransportPaidFlg },
  { label: '育児支援制度充実', value: recommendedPointChildcareSupportFlg },
  { label: '社宅・家賃補助制度', value: recommendedPointComHouseSupportFlg },
  { label: '研修制度充実', value: recommendedPointTrainingFlg },
  { label: '駅から徒歩5分以内', value: recommendedPointStationFrom_5Flg },
  { label: '服装自由', value: recommendedPointClothingFreeFlg },
  { label: '髪型自由', value: recommendedPointHairstyleFreeFlg },
  { label: '上場企業', value: recommendedPointListedFlg },
  { label: '外資系企業', value: recommendedPointForeignComFlg },
  { label: '2年連続売上10％以上UP', value: recommendedPoint2year_10percentFlg },
  { label: '設立5年以内', value: recommendedPointFounded_5yearFlg },
  { label: '中途入社5割以上', value: recommendedPointMidcareerIn_50Flg },
  { label: '女性社員が5割以上', value: recommendedPointFemale_50percentFlg },
  { label: '女性が活躍中', value: recommendedPointFemaleActiveFlg },
  { label: '未経験者歓迎', value: recommendedPointInexperienceFlg },
  { label: '第二新卒歓迎', value: recommendedPointSemiGradFlg },
  { label: '学歴不問', value: recommendedPointNoEducationFlg },
  { label: '語学を活かす-英語', value: recommendedPointUseEnglishFlg },
  { label: '語学を活かす-英語以外', value: recommendedPointUseOtherEnglishFlg },
  { label: '部長・幹部・管理職募集', value: recommendedPointManagerRecruitFlg },
  { label: 'U・Iターン歓迎', value: recommendedPointUiTurnFlg },
  { label: 'しゅふクリ・ママクリ', value: recommendedPointShufumamaFlg },
  { label: 'エグゼクティブ', value: recommendedPointExecutiveFlg },
]);
//勤務地
const masterDataSearchConditionWorkArea = ref<CheckboxListType[]>([]);
const shownWorkAreaModal = ref(false);
const openWorkAreaModal = () => {
  shownWorkAreaModal.value = true;
};
const closeWorkAreaModal = () => (shownWorkAreaModal.value = false);
const clearWorkArea = () => {
  workAreaList.value = [];
};
//業種
const industryTargetIndex = ref<number>(0);
const masterDataIndustryList = computed(() => store.getters['master/mstIndsctgCheckboxList']);
const mstIndsctgFlat = computed(() => store.getters['master/mstIndsctgFlat']);
const selectedIndustryText = (index: number) => {
  return industryList.value[index].map((i) => mstIndsctgFlat.value[i]).join('、');
};
const allIndustryTextList = computed(() => {
  const textArray = industryList.value
    .map((i) => {
      return i.map((j) => mstIndsctgFlat.value[j]).flat();
    })
    .flat();
  // 重複削除
  return Array.from(new Set(textArray));
});
const shownIndustryModal = ref(false);
const openIndustryModal = (id: number) => {
  shownIndustryModal.value = true;
  industryTargetIndex.value = id;
};
const closeIndustryModal = () => (shownIndustryModal.value = false);
const clearIndustry = (id: number) => {
  industryList.value[id] = [];
};
const addIndustryList = () => {
  industryList.value.push([]);
};
const mstIndsctgParentToChildrenArray = computed(() => store.getters['master/mstIndsctgParentToChildrenArray']);
const indsctgId = computed(() => (industryList.value.flat().length ? industryList.value.flat().map(Number) : null));
const indsctgIdForApi = computed(() => {
  if (!indsctgId.value) return null;
  const tmp = indsctgId.value.map((i) => {
    if (mstIndsctgParentToChildrenArray.value[i]) {
      return mstIndsctgParentToChildrenArray.value[i];
    }
    return i;
  });
  return tmp.flat();
});

const mstOcupClassParentToChildrenArray = computed(() => store.getters['master/mstOcupClassParentToChildrenArray']);
const ocupctgId = computed(() => (ocupList.value.flat().length ? ocupList.value.flat() : null));
const ocupctgIdForApi = computed(() => {
  if (!ocupctgId.value) return null;
  const tmp = ocupctgId.value.map((i) => {
    if (mstOcupClassParentToChildrenArray.value[i]) {
      return mstOcupClassParentToChildrenArray.value[i];
    }
    return i;
  });
  return tmp.flat();
});
//職種
const ocupTargetIndex = ref<number>(0);
const masterDataOcupList = computed(() => store.getters['master/mstOcupClassAllCheckboxList']);
const mstOcupClassFlat = computed(() => store.getters['master/mstOcupClassFlat']);
const selectedOcupClassText = (index: number) => {
  return ocupList.value[index].map((i) => mstOcupClassFlat.value[i]).join('、');
};
const allOcupClassTextList = computed(() => {
  const textArray = ocupList.value
    .map((i) => {
      return i.map((j) => mstOcupClassFlat.value[j]).flat();
    })
    .flat();
  // 重複削除
  return Array.from(new Set(textArray));
});
const shownOcupModal = ref(false);
const openOcupModal = (id: number) => {
  shownOcupModal.value = true;
  ocupTargetIndex.value = id;
};
const closeOcupModal = () => (shownOcupModal.value = false);
const clearOcup = (id: number) => {
  ocupList.value[id] = [];
};
const addOcupList = () => {
  ocupList.value.push([]);
};

const init = async () => {
  isLoading.value = true;
  try {
    const [resMstSearchConditionWorkArea] = await Promise.all([
      getMasterSearchConditionWorkArea(),
      store.dispatch('master/getMasterDataListIndsctg'),
      store.dispatch('master/getMasterDataOcupClass'),
    ]);

    masterDataSearchConditionWorkArea.value = resMstSearchConditionWorkArea.map((i) => {
      return {
        type: 'default',
        label: i.areaName,
        value: i.areaName,
        children: i.searchConditionWorkPrefDataList.map((j) => {
          return {
            type: 'checkbox',
            label: j.prefName,
            value: String(j.predId),
          };
        }),
      };
    });
  } catch (error) {
    console.error(error);
  } finally {
    isLoading.value = false;
  }
};
init();
// 選択した勤務地の値に該当するテキストを設定する
const WorkAreaTextList = computed(() => {
  return masterDataSearchConditionWorkArea.value.map((i) => i.children).flat();
});
const selectedWorkAreaText = computed(() => {
  let createTextList = [];
  for (let index = 0; index < workAreaList.value.length; index++) {
    const createText = WorkAreaTextList.value.find((v) => {
      if (v !== undefined) {
        return v.value === workAreaList.value[index];
      }
    })?.label;
    createTextList.push(createText);
  }
  return createTextList.join('、');
});

const sendSearch = () => {
  store.commit('searchOrder/setIdsForApi', {
    indsctgIdForApi: indsctgIdForApi.value,
    ocupctgIdForApi: ocupctgIdForApi.value,
  });
  store.commit('searchOrder/setSendSearchOrder', {
    keyword: keyword.value,
    orderId: orderId.value ? Number(orderId.value) : null,
    indsctgId: indsctgId.value,
    ocupctgId: ocupctgId.value,
    salaryMax: salaryMax.value ? Number(salaryMax.value) : null,
    salaryMin: salaryMin.value ? Number(salaryMin.value) : null,
    wkprefId: workAreaList.value.length ? workAreaList.value.map(Number) : null,
    emptypeFulltimeemployeeFlg: emptypeFulltimeemployeeFlg.value,
    emptypeContractemployeeFlg: emptypeContractemployeeFlg.value,
    emptypeTemporarystaffFlg: emptypeTemporarystaffFlg.value,
    emptypeIntroductiondispatchingFlg: emptypeIntroductiondispatchingFlg.value,
    emptypeSubcontractingFlg: emptypeSubcontractingFlg.value,
    recommendedPoint1_4DayworkFlg: recommendedPoint1_4DayworkFlg.value,
    recommendedPointWeekendOffFlg: recommendedPointWeekendOffFlg.value,
    recommendedPointSrtWkhourFlg: recommendedPointSrtWkhourFlg.value,
    recommendedPoint1_5HourworkFlg: recommendedPoint1_5HourworkFlg.value,
    recommendedPointNoOvertimeFlg: recommendedPointNoOvertimeFlg.value,
    recommendedPointOvertimeFlg: recommendedPointOvertimeFlg.value,
    recommendedPointWorkFrom_10Flg: recommendedPointWorkFrom_10Flg.value,
    recommendedPointWorkTo_18Flg: recommendedPointWorkTo_18Flg.value,
    recommendedPointFlextimeFlg: recommendedPointFlextimeFlg.value,
    recommendedPointSalary_130Flg: recommendedPointSalary_130Flg.value,
    recommendedPointHomeBasedFlg: recommendedPointHomeBasedFlg.value,
    recommendedPointSideWorkFlg: recommendedPointSideWorkFlg.value,
    recommendedPointNoRelocationFlg: recommendedPointNoRelocationFlg.value,
    recommendedPointTransportPaidFlg: recommendedPointTransportPaidFlg.value,
    recommendedPointChildcareSupportFlg: recommendedPointChildcareSupportFlg.value,
    recommendedPointComHouseSupportFlg: recommendedPointComHouseSupportFlg.value,
    recommendedPointTrainingFlg: recommendedPointTrainingFlg.value,
    recommendedPointStationFrom_5Flg: recommendedPointStationFrom_5Flg.value,
    recommendedPointClothingFreeFlg: recommendedPointClothingFreeFlg.value,
    recommendedPointHairstyleFreeFlg: recommendedPointHairstyleFreeFlg.value,
    recommendedPointListedFlg: recommendedPointListedFlg.value,
    recommendedPointForeignComFlg: recommendedPointForeignComFlg.value,
    recommendedPoint2year_10percentFlg: recommendedPoint2year_10percentFlg.value,
    recommendedPointFounded_5yearFlg: recommendedPointFounded_5yearFlg.value,
    recommendedPointMidcareerIn_50Flg: recommendedPointMidcareerIn_50Flg.value,
    recommendedPointFemale_50percentFlg: recommendedPointFemale_50percentFlg.value,
    recommendedPointFemaleActiveFlg: recommendedPointFemaleActiveFlg.value,
    recommendedPointInexperienceFlg: recommendedPointInexperienceFlg.value,
    recommendedPointSemiGradFlg: recommendedPointSemiGradFlg.value,
    recommendedPointNoEducationFlg: recommendedPointNoEducationFlg.value,
    recommendedPointUseEnglishFlg: recommendedPointUseEnglishFlg.value,
    recommendedPointUseOtherEnglishFlg: recommendedPointUseOtherEnglishFlg.value,
    recommendedPointManagerRecruitFlg: recommendedPointManagerRecruitFlg.value,
    recommendedPointUiTurnFlg: recommendedPointUiTurnFlg.value,
    recommendedPointShufumamaFlg: recommendedPointShufumamaFlg.value,
    recommendedPointExecutiveFlg: recommendedPointExecutiveFlg.value,
  });

  // 検索条件を保存
  const empTypeTextList = empTypeList.value
    .filter((x) => {
      return x.value;
    })
    .map((x) => {
      return x.label;
    });
  const recommendedPointTextList = recommendedPointList.value
    .filter((x) => {
      return x.value;
    })
    .map((x) => {
      return x.label;
    });
  store.commit('searchOrder/setSearchOrderConditions', {
    keyword: keyword.value,
    orderId: orderId.value,
    indsctgList: industryList.value.length ? industryList.value : undefined,
    indsctgIdToTextList: allIndustryTextList.value.length > 0 ? allIndustryTextList.value : undefined,
    ocupToTextList: allOcupClassTextList.value.length > 0 ? allOcupClassTextList.value : undefined,
    ocupList: ocupList.value.length ? ocupList.value : undefined,
    workAreaTextList: selectedWorkAreaText.value ? selectedWorkAreaText.value.split('、') : undefined,
    empTypeTextList: empTypeTextList.length ? empTypeTextList : undefined,
    recommendedPointTextList: recommendedPointTextList.length ? recommendedPointTextList : undefined,
    salaryMin: salaryMin.value ? salaryMin.value : undefined,
    salaryMax: salaryMax.value ? salaryMax.value : undefined,
  });
  router.push({ name: 'h10' });
};
const resetForm = () => {
  (keyword.value = ''), (orderId.value = ''), (industryList.value = [[]]), (ocupList.value = [[]]);
  salaryMax.value = '';
  salaryMin.value = '';
  (workAreaList.value = []), (emptypeFulltimeemployeeFlg.value = false);
  emptypeContractemployeeFlg.value = false;
  emptypeTemporarystaffFlg.value = false;
  emptypeIntroductiondispatchingFlg.value = false;
  emptypeSubcontractingFlg.value = false;
  recommendedPoint1_4DayworkFlg.value = false;
  recommendedPointWeekendOffFlg.value = false;
  recommendedPointSrtWkhourFlg.value = false;
  recommendedPoint1_5HourworkFlg.value = false;
  recommendedPointNoOvertimeFlg.value = false;
  recommendedPointOvertimeFlg.value = false;
  recommendedPointWorkFrom_10Flg.value = false;
  recommendedPointWorkTo_18Flg.value = false;
  recommendedPointFlextimeFlg.value = false;
  recommendedPointSalary_130Flg.value = false;
  recommendedPointHomeBasedFlg.value = false;
  recommendedPointSideWorkFlg.value = false;
  recommendedPointNoRelocationFlg.value = false;
  recommendedPointTransportPaidFlg.value = false;
  recommendedPointChildcareSupportFlg.value = false;
  recommendedPointComHouseSupportFlg.value = false;
  recommendedPointTrainingFlg.value = false;
  recommendedPointStationFrom_5Flg.value = false;
  recommendedPointClothingFreeFlg.value = false;
  recommendedPointHairstyleFreeFlg.value = false;
  recommendedPointListedFlg.value = false;
  recommendedPointForeignComFlg.value = false;
  recommendedPoint2year_10percentFlg.value = false;
  recommendedPointFounded_5yearFlg.value = false;
  recommendedPointMidcareerIn_50Flg.value = false;
  recommendedPointFemale_50percentFlg.value = false;
  recommendedPointFemaleActiveFlg.value = false;
  recommendedPointInexperienceFlg.value = false;
  recommendedPointSemiGradFlg.value = false;
  recommendedPointNoEducationFlg.value = false;
  recommendedPointUseEnglishFlg.value = false;
  recommendedPointUseOtherEnglishFlg.value = false;
  recommendedPointManagerRecruitFlg.value = false;
  recommendedPointUiTurnFlg.value = false;
  recommendedPointShufumamaFlg.value = false;
  recommendedPointExecutiveFlg.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(BaseTextForm, {
                modelValue: keyword.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((keyword).value = $event)),
                placeholder: "入力してください",
                maxlength: 1000
              }, null, 8, ["modelValue"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(industryList.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "search_item_form"
              }, [
                _createVNode(BaseSelectButton, {
                  placeholder: "選択してください",
                  modelValue: selectedIndustryText(index),
                  onClick: ($event: any) => (openIndustryModal(index)),
                  onClear: ($event: any) => (clearIndustry(index))
                }, null, 8, ["modelValue", "onClick", "onClear"])
              ]))
            }), 128)),
            _createElementVNode("div", _hoisted_12, [
              (industryList.value.length < 5)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: addIndustryList,
                    class: "button_search_add"
                  }, "+条件を追加"))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ocupList.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "search_item_form"
              }, [
                _createVNode(BaseSelectButton, {
                  placeholder: "選択してください",
                  modelValue: selectedOcupClassText(index),
                  onClick: ($event: any) => (openOcupModal(index)),
                  onClear: ($event: any) => (clearOcup(index))
                }, null, 8, ["modelValue", "onClick", "onClear"])
              ]))
            }), 128)),
            _createElementVNode("div", _hoisted_16, [
              (ocupList.value.length < 5)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: addOcupList,
                    class: "button_search_add"
                  }, "+条件を追加"))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createVNode(BaseSelectButton, {
                placeholder: "選択してください",
                modelValue: _unref(selectedWorkAreaText),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(selectedWorkAreaText) ? (selectedWorkAreaText).value = $event : null)),
                onClick: openWorkAreaModal,
                onClear: clearWorkArea
              }, null, 8, ["modelValue"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(empTypeList.value, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.label,
                  class: "search_item_checkbox_cell"
                }, [
                  _createVNode(BaseCheckbox, {
                    value: false,
                    label: item.label,
                    modelValue: item.value,
                    "onUpdate:modelValue": ($event: any) => ((item.value) = $event)
                  }, null, 8, ["label", "modelValue", "onUpdate:modelValue"])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(BaseTextForm, {
                      modelValue: _unref(salaryMin),
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(salaryMin) ? (salaryMin).value = $event : null)),
                      placeholder: "400",
                      maxlength: 13,
                      isError: !!_unref(errors).salaryMin
                    }, null, 8, ["modelValue", "isError"])
                  ]),
                  _hoisted_32
                ])
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _createVNode(BaseTextForm, {
                      modelValue: _unref(salaryMax),
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(salaryMax) ? (salaryMax).value = $event : null)),
                      placeholder: "450",
                      maxlength: 13,
                      isError: !!_unref(errors).salaryMax
                    }, null, 8, ["modelValue", "isError"])
                  ]),
                  _hoisted_36
                ])
              ])
            ]),
            (_unref(salaryErrors)?.length)
              ? (_openBlock(), _createBlock(ErrorMessage, {
                  key: 0,
                  errors: _unref(salaryErrors)
                }, null, 8, ["errors"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_37, [
          _hoisted_38,
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pickUpPointList.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "search_item_checkbox_cell"
                }, [
                  _createVNode(BaseCheckbox, {
                    value: false,
                    modelValue: item.value,
                    "onUpdate:modelValue": ($event: any) => ((item.value) = $event),
                    label: item.label
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "label"])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_41, [
          (!isShowMoreContents.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[4] || (_cache[4] = () => (isShowMoreContents.value = true)),
                class: "button_read_more"
              }, " こだわりをもっと見る "))
            : _createCommentVNode("", true)
        ]),
        (isShowMoreContents.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _hoisted_44,
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recommendedPointList.value.slice(0, 13), (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "search_item_checkbox_cell"
                      }, [
                        _createVNode(BaseCheckbox, {
                          value: false,
                          modelValue: item.value,
                          "onUpdate:modelValue": ($event: any) => ((item.value) = $event),
                          label: item.label
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "label"])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_47, [
                _hoisted_48,
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recommendedPointList.value.slice(13, 17), (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "search_item_checkbox_cell"
                      }, [
                        _createVNode(BaseCheckbox, {
                          value: false,
                          modelValue: item.value,
                          "onUpdate:modelValue": ($event: any) => ((item.value) = $event),
                          label: item.label
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "label"])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_51, [
                _hoisted_52,
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("div", _hoisted_54, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recommendedPointList.value.slice(17, 20), (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "search_item_checkbox_cell"
                      }, [
                        _createVNode(BaseCheckbox, {
                          value: false,
                          modelValue: item.value,
                          "onUpdate:modelValue": ($event: any) => ((item.value) = $event),
                          label: item.label
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "label"])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_55, [
                _hoisted_56,
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("div", _hoisted_58, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recommendedPointList.value.slice(20, 24), (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "search_item_checkbox_cell"
                      }, [
                        _createVNode(BaseCheckbox, {
                          value: false,
                          modelValue: item.value,
                          "onUpdate:modelValue": ($event: any) => ((item.value) = $event),
                          label: item.label
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "label"])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_59, [
                _hoisted_60,
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("div", _hoisted_62, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recommendedPointList.value.slice(24, 27), (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "search_item_checkbox_cell"
                      }, [
                        _createVNode(BaseCheckbox, {
                          value: false,
                          modelValue: item.value,
                          "onUpdate:modelValue": ($event: any) => ((item.value) = $event),
                          label: item.label
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "label"])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_63, [
                _hoisted_64,
                _createElementVNode("div", _hoisted_65, [
                  _createElementVNode("div", _hoisted_66, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recommendedPointList.value.slice(27), (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "search_item_checkbox_cell"
                      }, [
                        _createVNode(BaseCheckbox, {
                          value: false,
                          modelValue: item.value,
                          "onUpdate:modelValue": ($event: any) => ((item.value) = $event),
                          label: item.label
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "label"])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_67, [
                _createElementVNode("button", {
                  onClick: _cache[5] || (_cache[5] = () => (isShowMoreContents.value = false)),
                  class: "button_read_more is-open"
                }, "こだわりを閉じる")
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_68, [
          _hoisted_69,
          _createElementVNode("div", _hoisted_70, [
            _createElementVNode("div", _hoisted_71, [
              _createVNode(BaseTextForm, {
                modelValue: _unref(orderId),
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(orderId) ? (orderId).value = $event : null)),
                placeholder: "求人番号で検索",
                maxlength: 13
              }, null, 8, ["modelValue"])
            ]),
            (_unref(errors).orderId)
              ? (_openBlock(), _createBlock(ErrorMessage, {
                  key: 0,
                  errors: [_unref(errors).orderId]
                }, null, 8, ["errors"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_72, [
          _createElementVNode("div", _hoisted_73, [
            _createElementVNode("div", _hoisted_74, [
              _createVNode(BaseButton, {
                onClick: resetForm,
                theme: "tertiary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("クリア")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_75, [
              _createVNode(BaseButton, {
                onClick: sendSearch,
                theme: "primary",
                disabled: !_unref(meta).valid
              }, {
                default: _withCtx(() => [
                  _createTextVNode("この条件で検索")
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ])
        ])
      ])
    ]),
    (shownWorkAreaModal.value)
      ? (_openBlock(), _createBlock(EditCheckboxModal, {
          key: 0,
          title: "勤務地（複数選択可）",
          modelValue: workAreaList.value,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((workAreaList).value = $event)),
          list: masterDataSearchConditionWorkArea.value,
          onClose: closeWorkAreaModal
        }, null, 8, ["modelValue", "list"]))
      : _createCommentVNode("", true),
    (shownIndustryModal.value)
      ? (_openBlock(), _createBlock(EditCheckboxModal, {
          key: 1,
          title: "業種（複数選択可）",
          modelValue: industryList.value[industryTargetIndex.value],
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((industryList.value[industryTargetIndex.value]) = $event)),
          list: _unref(masterDataIndustryList),
          onClose: closeIndustryModal
        }, null, 8, ["modelValue", "list"]))
      : _createCommentVNode("", true),
    (shownOcupModal.value)
      ? (_openBlock(), _createBlock(EditCheckboxModal, {
          key: 2,
          title: "職種（複数選択可）",
          modelValue: ocupList.value[ocupTargetIndex.value],
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((ocupList.value[ocupTargetIndex.value]) = $event)),
          list: _unref(masterDataOcupList),
          onClose: closeOcupModal
        }, null, 8, ["modelValue", "list"]))
      : _createCommentVNode("", true)
  ]))
}
}

})